import { all } from 'redux-saga/effects';
import { watchList } from './list';
import { watchCreate } from './create';
import { watchDelete } from './delete';
import { watchUpdate } from './update';
import { watchGet } from './get';
import watchClaimSms from './claim';

export function* watchSMSConfig() {
  yield all([
    watchList(),
    watchCreate(),
    watchDelete(),
    watchUpdate(),
    watchGet(),
    watchClaimSms(),
  ]);
}
